"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedCapacity = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
const roleGroupCallback = (item) => item.engineer.role || "";
const regionGroupCallback = (item) => item.engineer.region || "";
class AggregatedCapacity {
    constructor() {
        this.allocatedEngineers = 0;
        this.allocatedHours = 0;
        this.items = {};
        this.getGrossUtilizationHours = (0, memoizee_1.default)(() => {
            return (Object.values(this.items) || []).reduce((sum, item) => {
                return sum + item.getGrossUtilizationHours();
            }, 0);
        });
    }
    add(capacity) {
        this.allocatedEngineers++;
        this.allocatedHours += capacity.getUtilizationHours();
        this.items[capacity.engineer.id] = capacity;
        this.getGrossUtilizationHours.clear();
    }
    getItems() {
        return Object.values(this.items);
    }
    getGroupedAggregatedCapacity(callback) {
        return this.getItems().reduce((map, item) => {
            const group = callback(item);
            if (!map[group]) {
                map[group] = new AggregatedCapacity();
            }
            map[group].add(item);
            return map;
        }, {});
    }
    getAggregatedCapacityByRole() {
        return this.getGroupedAggregatedCapacity(roleGroupCallback);
    }
    getAggregatedCapacityByRegion() {
        return this.getGroupedAggregatedCapacity(regionGroupCallback);
    }
}
exports.AggregatedCapacity = AggregatedCapacity;
//# sourceMappingURL=AggregatedCapacity.js.map